import React from 'react';
import { Box, Typography, Grid, Link as MuiLink, IconButton } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

export default function Footer() {
  return (
    <Box sx={{ p: { xs: 2, sm: 4 }, mt: 4, backgroundColor: '#f5f5f5', textAlign: 'center' }}>
      <Grid 
        container 
        spacing={2} 
        direction={{ xs: 'column', sm: 'row' }} 
        justifyContent={{ xs: 'flex-start', sm: 'center' }} 
        alignItems={{ xs: 'center', sm: 'flex-start' }}
      >
        <Grid item xs={12} sm={4} sx={{ mb: { xs: 2, sm: 0 } }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography variant="h6" gutterBottom>Quick Links</Typography>
            <MuiLink href="/" underline="hover" color="inherit" display="block">Home</MuiLink>
            <MuiLink href="/about" underline="hover" color="inherit" display="block">About Us</MuiLink>
            <MuiLink href="/products" underline="hover" color="inherit" display="block">Our Products</MuiLink>
            <MuiLink href="/contact" underline="hover" color="inherit" display="block">Contact Us</MuiLink>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4} sx={{ mb: { xs: 2, sm: 0 } }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography variant="h6" gutterBottom>Contact Info</Typography>
            <Typography variant="body2">+91-9974301565</Typography>
            <Typography variant="body2">aqeushealthcare@gmail.com</Typography>
            <Typography variant="body2">161 VANKAL DARU FALIYA, near jalaram sawe mill Valsad</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography variant="h6" gutterBottom>Follow Us</Typography>
            <Box>
              <IconButton href="#" color="inherit"><FacebookIcon /></IconButton>
              <IconButton href="#" color="inherit"><InstagramIcon /></IconButton>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Typography variant="body2" sx={{ mt: 3, textAlign: 'center' }}>© 2025 Aques Healthcare. All rights reserved.</Typography>
    </Box>
  );
}